import { useMemo, useState } from "react";
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { getPersonalization } from "@/lib/funnelData";
import { Preloader } from "@/components/Preloader";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { ValuationFunnel } from "@/components/ValuationFunnel";
import { AboutJody } from "@/components/AboutJody";
import { Counties } from "@/components/Counties";
import { Footer } from "@/components/Footer";
import { PrivacyPage, TermsPage } from "@/components/LegalPages";

const FunnelPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const p = useMemo(() => getPersonalization(searchParams), [searchParams]);
  const [prefillAddress, setPrefillAddress] = useState("");

  const startFunnel = (address) => {
    setPrefillAddress(address);
    document.getElementById("funnel")?.scrollIntoView({ behavior: "smooth" });
  };

  const selectCounty = (key) => {
    const next = new URLSearchParams(searchParams);
    next.set("county", key);
    setSearchParams(next);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-canvas font-sans" data-testid="funnel-page">
      <Preloader />
      <Header countyName={p.countyName} />
      <main>
        <Hero p={p} onStart={startFunnel} />
        <ValuationFunnel p={p} prefillAddress={prefillAddress} />
        <AboutJody />
        <Counties activeCounty={p.countyKey} onSelect={selectCounty} />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<FunnelPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
    </BrowserRouter>
  );
}
